import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    internetConnectionIssue: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: theme.colors.black,
        backdropFilter: 'blur(10px)',
        opacity: 0.9,
        zIndex: theme.zIndexLevels.three,

        '& p': {
            display: 'inline-block',
            fontFamily: theme.typographyPresets.fonts.notoSans.bold,
            color: theme.colors.white,
            position: 'absolute',
            right: '50%',
            transform: 'translate(50%, -50%)',
            fontSize: 14,
            lineHeight: 2.86,
            letterSpacing: '0.56px',
            top: '42%',
            zIndex: theme.zIndexLevels.one,

            '@media (min-width: 768px)': {
                fontSize: 20,
                top: '45%',
                lineHeight: 2,
                letterSpacing: '0.8px',
            },
        },
    },
}))
